import React, { useEffect } from 'react'
import { SideMain } from './menu-area/SideMain'
import { SecondaryContainer } from './subContent/SecondaryContainer'
import { HeaderMain } from './subContent/responsiveHeader/HeaderMain'
import { useDispatch } from 'react-redux'
import { allCommonData } from '../../redux/slices/commonApiData'
import { ToastContainer } from 'react-toastify'


export const Dashboard = () => {

const dispatch = useDispatch()


//? llamada a los datos comunes de la API para proveer a toda la app de la info/data
useEffect(() => {
    dispatch(allCommonData())

  }, [dispatch])

    return (
        <div className='container cont-principal'>

            <div className="row row-class">

                <ToastContainer/>
                <SideMain/>

                <SecondaryContainer/>

                <HeaderMain/>

            </div>


            

        </div>




    )
}
